import React from 'react';
import { Tooltip } from 'freemium-ui';
import Icon from 'shared/components/Icon';
import { PageDataType } from 'shared/types';
import { convertQuillHTMLToText } from 'shared/utils';
import { StyledPageDescTooltip } from './style';

type ResponsePageTitleAndDescProps = {
  page: PageDataType | undefined;
};

const ResponsePageTitleAndDesc = (props: ResponsePageTitleAndDescProps) => {
  const { page } = props;
  return (
    <div className="page-name-desc-container">
      <div className="page-name">
        {page?.name}
        {page?.title &&
          convertQuillHTMLToText(page?.title || '').length > 0 && (
            <>{`: ${convertQuillHTMLToText(page?.title || '')}`}</>
          )}
      </div>
      {page?.description &&
        convertQuillHTMLToText(page?.description || '').length > 0 && (
          <Tooltip
            html={
              <StyledPageDescTooltip
                dangerouslySetInnerHTML={{
                  __html: page?.description.replace(/<\/?p>/g, ''),
                }}
              />
            }
            position="right"
          >
            <Icon glyph="info" width="12" height="12" />
          </Tooltip>
        )}
    </div>
  );
};

export default ResponsePageTitleAndDesc;
